<template>
    <div 
    class="file-preview m-1 relative aspect-square overflow-hidden rounded flex flex-col border whitespace-pre-wrap"
        @mouseenter="showLinkMenu"
        @mouseleave="hideLinkMenu"
    >
        <div v-if="defaultThumbnail && allowLinkPreview" @click="showLinkPreview" class="w-full h-full rounded-t bg-primary-dark flex justify-center items-center text-primary-extra-dark text-bold text-2xl cursor-zoom-in">
            <div>{{ defaultThumbnail }}</div>
        </div>
        <div v-else-if="defaultThumbnail" class="w-full h-full rounded-t bg-primary-dark flex flex-col justify-center items-center text-primary-extra-dark text-bold text-2xl">
            <div>{{ defaultThumbnail }}</div>
            <div class="text-base">(No Link Preview)</div>
        </div>
        <img v-else class="w-full h-[85%] block object-cover rounded-t whitespace-pre-wrap cursor-zoom-in" :src="file.iconURL"
            @click="showLinkPreview"
        />
        <div class="rounded-b flex justify-between w-full pl-2 h-8">
            <div class="truncate">
                {{ file.title }}
            </div>
            <div v-if="linkMenuVisible" class="w-fit min-w-16 flex justify-end">
                <a @mouseenter="changeDownloadFillLight" @mouseleave="changeDownloadFillDark" :href="file.link"  class="h-7 w-7 rounded-br flex justify-center items-center cursor-pointer" aria-label="Download" target="_blank">
                    <ExternalLinkSVG
                        :stroke-width="1.5"
                        :stroke-color="downloadSVGFill"
                    />
                </a>
                <div v-if="!readMode" @click.prevent="$emit('remove', file._id)" @mouseenter="changeTrashFillLight" @mouseleave="changeTrashFillDark"  class="h-7 w-7 rounded-br flex justify-center items-center cursor-pointer" aria-label="Remove">
                    <TrashSVG
                        :fill="trashSVGFill"
                    />
                </div>
            </div>
        </div>
        <base-modal
            v-if="linkPreviewVisible"
            :show-modal-menu-button="false"
            :stack="1"
            :is-form-visible="linkPreviewVisible"
            @close="hideLinkPreview"
        >
            <template #header>
                <div class="text-2xl text-primary-extra-dark">
                    Link Preview:
                </div>
            </template>
            <template #body>
                <LinkPreview
                :is-dropbox-link="isDropboxLink"
                :link="file.link"
            />
            </template>
        </base-modal>
    </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';
import LinkPreview from '@/components/base-components/LinkPreview.vue';
import TrashSVG from '@/components/svg-components/TrashSVG.vue';
import ExternalLinkSVG from '@/components/svg-components/ExternalLinkSVG.vue';

const props = defineProps(['file', 'readMode'])
defineEmits(['remove'])

const trashSVGFill = ref("#737373")
const downloadSVGFill = ref("#737373")
const linkMenuVisible = ref(false)
const linkPreviewVisible = ref(false)


const defaultThumbnail = computed(() => {
    if(props.file.extension == '. ppt') {
        return 'PPT'
    } else if(props.file.extension == '. pdf') {
        return 'PDF'
    } else {
        return null
    }
})
 const allowLinkPreview = computed(() => {
    if(props.file.extension.includes('ppt')) {
        return false
    } else {
        return true
    }
 })

 const isDropboxLink = computed(() => {
    if(props.file.title) {
        return true
    }
    if(props.file.link.includes('www.dropbox.com')) {
        return true
    }
    return false
 })

function showLinkPreview() {
    linkPreviewVisible.value = true
}

function hideLinkPreview() {
    linkPreviewVisible.value = false  
}

function showLinkMenu() {
    linkMenuVisible.value = true
}

function hideLinkMenu() {
    linkMenuVisible.value = false
}

function changeTrashFillLight() {
    trashSVGFill.value = "#262626"
}

function changeTrashFillDark() {
    trashSVGFill.value = "#737373"
}

function changeDownloadFillLight() {
    downloadSVGFill.value = "#262626"
}

function changeDownloadFillDark() {
    downloadSVGFill.value = "#737373"
}

</script>